__turbopack_context__.v({
  "backdrop": "IdiomaModalSelector-module__cVyRKa__backdrop",
  "fadeIn": "IdiomaModalSelector-module__cVyRKa__fadeIn",
  "flagBadge": "IdiomaModalSelector-module__cVyRKa__flagBadge",
  "iconBadge": "IdiomaModalSelector-module__cVyRKa__iconBadge",
  "languageButton": "IdiomaModalSelector-module__cVyRKa__languageButton",
  "languageButtonSelected": "IdiomaModalSelector-module__cVyRKa__languageButtonSelected",
  "languageList": "IdiomaModalSelector-module__cVyRKa__languageList",
  "modalCard": "IdiomaModalSelector-module__cVyRKa__modalCard",
  "zoomIn": "IdiomaModalSelector-module__cVyRKa__zoomIn",
});
